import { IAppState } from 'shared/common/state';

export const selectRandomBoolean = (state: IAppState) => state.randomBoolean;
